import React from "react"

export type TextProps = {
  children: React.ReactNode
}

export const Text = ({ children }: TextProps) => (
  <article className="prose-blockquote:italic prose-ol:list-decimal prose-ul:list-disc prose-a:text-brand-accent prose-a:underline prose-xl w-full text-gray-900">
    {children}
  </article>
)
